import React from "react";

import PhotoGallery from "../../components/photo-gallery/photo-gallery";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons";

import "./photos.scss";

library.add(faCameraRetro);

//class Photos extends Component {
function Photos() {
  return (
    <div className="photos-page">
      <div className="page-content gutter">
        <h1>Photos</h1>
        <div className="row title-row">
          <FontAwesomeIcon className="page-icon" icon={faCameraRetro} />
          <div className="page-copy">
            <p>
              Each snapshot tells a story, freezing moments in time that resonate with the passion and power of our music.
              Whether it's the intensity of a live show, the camaraderie backstage, the dedication of the practice room, or just us goofing around,
              these photos provide a glimpse into the lifeblood of Salty.
            </p>
          </div>
        </div>
        <div className="row photo-gallery">
          <PhotoGallery />
        </div>
      </div>
    </div>
  );
}

export default Photos;